import Vue from 'vue'
import Vuex from 'vuex'
import Common from './api/common'

Vue.use(Vuex)

// 系统配置默认值
const defaultSystemConfig = {
	system_name: '财务管理系统',
	copyright: 'Copyright © 2024'
}

export default new Vuex.Store({
	state: {
		User: {},
		currentAccountSets: {},
		myAccountSets: [],
		sliderCollapsed: false,
		allowedMenus: null,  // null 表示不限制
		systemConfig: { ...defaultSystemConfig }
	},
	mutations: {
		updateAccount(state, data) {
			state.User = data;
			state.currentAccountSets = data.accountSets;
			state.myAccountSets = data.accountSetsList;
			state.allowedMenus = data.allowedMenus || null;
		},
		updateSliderCollapse(state, isShow) {
			setTimeout(() => {
				G.trigger('page_resize');
			}, 600);
			state.sliderCollapsed = isShow;
		},
		updateSystemConfig(state, config) {
			state.systemConfig = { ...defaultSystemConfig, ...config };
		}
	},
	actions: {
		init(context) {
			return new Promise((resolve, reject) => {
				// 先获取系统配置
				Common.getSystemConfig().then(({data}) => {
					context.commit('updateSystemConfig', data);
				}).catch(() => {
					// 配置获取失败使用默认值
				});
				
				// 再获取用户信息
				Common.init().then(({data}) => {
					context.commit('updateAccount', data);
					resolve(data)
				}).catch(() => {
					reject();
				})
			});
		},
		loadSystemConfig(context) {
			return new Promise((resolve) => {
				Common.getSystemConfig().then(({data}) => {
					context.commit('updateSystemConfig', data);
					resolve(data);
				}).catch(() => {
					resolve(context.state.systemConfig);
				});
			});
		}
	},
	getters: {
		account: state => {
			return state.User;
		},
		sliderCollapsed: state => {
			return state.sliderCollapsed;
		},
		systemConfig: state => {
			return state.systemConfig;
		}
	}
})
